import React from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS, ROUTE_PATHS } from '@constants';
import { Button, Icon, Typography } from '@ui';
import { Flex } from 'antd';

const NotConnected = () => {
    const navigate = useNavigate();
    return (
        <Flex vertical style={{ flexGrow: 1 }}>
            <Typography.Text data-e2e='campaigns_page_title' type='em0'>
                Campaigns
            </Typography.Text>
            <Flex align='center' justify='center' style={{ flexGrow: 1 }}>
                <Flex data-e2e='campaigns_not-connected-state_content' vertical align='center' gap={24}>
                    <Typography.Title data-e2e='campaigns_connect-store_text' level={2} color={COLORS.$gray60Black}>
                        Connect your store to Klickly to launch a new campaign
                    </Typography.Title>
                    <Button
                        data-e2e='campaigns_complete-setup_btn'
                        onClick={() => navigate(ROUTE_PATHS.INTEGRATIONS_SETTINGS)}
                        type='primary'
                        size='large'
                        iconRight={
                            <Icon size='24px' color={COLORS.$white} component={() => <Icon.ArrowForwardIcon />} />
                        }
                    >
                        Complete Set-Up
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
};

export default NotConnected;
